import {useAuthAxios} from 'hooks/api/useAuthAxios'
import {useFileDownload} from 'hooks/api/useFileDownload'

type Params = {
  target?: TargetType
  encoding?: EncodingType
  search?: string
}

export type TargetType = 'search' | 'all'
export type EncodingType = 'UTF-8' | 'Windows-31J'

export const useDownloadContractsCsv = () => {
  const authAxios = useAuthAxios()
  const {download} = useFileDownload()

  return async (employeeId: string, contractRequestId: string, params: Params) => {
    const path = `/api/employees/${employeeId}/export_employee_document_contract_csv/${contractRequestId}`
    const getter = () => authAxios.get(path, {responseType: 'arraybuffer', params})

    download(getter)
  }
}
